import React, { useState } from 'react';

import { Box, Typography, Paper, Button } from '@mui/material';
import { Assessment as AssessmentIcon } from '@mui/icons-material';
import { ColorRing } from 'react-loader-spinner'
import FileUpload from "../components/File/FileUpload";
const Audit = () => {

  const [newUserInfo, setNewUserInfo] = useState({ x12Docs: [] });
	const [postResult, setPostResult] = useState(null);
	const [spinner, setSpinner] = useState(false);

	const handleDownload = () => {
			};
	const formatResponse = (data) => {

		return (
			<Box >
				<Box>
					<Button onClick={handleDownload}>Download</Button>
				</Box>
			</Box>
		);
	}

	const updateUploadedFiles = (files) =>
		setNewUserInfo({ ...newUserInfo, x12Docs: files });

	const handleSubmit = async (event) => {
		event.preventDefault();
		// Simple POST request with a JSON body using fetch

		var formData = new FormData();
		// formData.append("name", name);
		formData.append("file", newUserInfo.x12Docs[0]);

		const requestOptions = {
			method: 'POST',
			body: formData
		};


		try {
			//let res = await fetch('http://localhost:8080/download/taper.xlsx', requestOptions);

			setSpinner(true);

			await fetch('http://localhost:8080/taper/generate', requestOptions)
				.then((response) => response.blob())
				.then((blob) => {
					// Create blob link to download
					const url = window.URL.createObjectURL(
						new Blob([blob]),
					);
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute(
						'download',
						`TaperQuote.xlsx`,
					);

					// Append to html link element page
					document.body.appendChild(link);

					// Start download
					link.click();

					// Clean up and remove the link
					link.parentNode.removeChild(link);
				});
			setSpinner(false);
		} catch (err) {
			setPostResult(err.message);
			setSpinner(false);
		}
	};


  return (
    <div className="main-content page-audit">
      <div>
				<form onSubmit={handleSubmit}>
					<FileUpload
						accept="*.txt"
						// label="Taper Report"
						updateFilesCb={updateUploadedFiles}
					/>
					<div style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}>
					</div>
          <button className="action" type="submit">Generate</button>
					
					<ColorRing
						visible={spinner}
						height="80"
						width="80"
						ariaLabel="blocks-loading"
						wrapperStyle={{}}
						wrapperClass="blocks-wrapper"
						colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
					/>
				</form>
			</div>

			<div>{postResult && <div className="alert alert-secondary mt-2" role="alert"><pre>{postResult}</pre></div>}</div>
    </div>
  );
};

export default Audit; 






